import { useCustomerCompanyRetrieve } from "@boundless/bl-api-client/customer/services"
import { useStore } from "zustand/react"

import { ContinueButton } from "@/components/home/ContinueButton"
import { LoadingButton } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"
import { store } from "@/lib/store"
import LenderComparisonImage from "@/svg/home/lender-comparison.svg?react"

export default function LenderMatchCard() {
  const activeCompanyUuid = useStore(store, (state) => state.activeCompanyUuid)

  const { data: company, isLoading: isCompanyLoading } =
    useCustomerCompanyRetrieve(activeCompanyUuid ?? "", {
      query: {
        enabled: !!activeCompanyUuid,
        staleTime: 0,
      },
    })

  return (
    <Card className="@container min-w-0 overflow-hidden p-6">
      <div className="grid h-full grid-cols-1 grid-rows-[auto_1fr] gap-4 @md:grid-cols-[1fr_auto]">
        <CardTitle>Lender Match</CardTitle>

        <LenderComparisonImage className="pointer-events-none row-span-2 hidden h-full w-48 @md:block" />
        <div className="flex min-w-0 flex-col justify-between">
          <p className="mb-4">
            Find suitable lenders based on your financial profile and business
            needs.
          </p>
          {isCompanyLoading ? (
            <LoadingButton className="w-22 self-start" />
          ) : (
            <ContinueButton company={company} />
          )}
        </div>
      </div>
    </Card>
  )
}
